module.exports = __webpack_public_path__ + "img/down.5e97a8b7.svg";